if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      // mundizio v3 (14.09.2026): Zaehler vor dem Add (serverseitig gerendert, leer = 0) — erkennt im
      // Fehlerfall, ob Shopify trotz 422 Stueck eingelegt hat (Teil-Add an der Bestandsgrenze).
      // Markup: <span aria-hidden="true">2</span><span class="visually-hidden">2 Artikel</span> -> nur den Zahl-Span lesen
      // (textContent beider Spans ergaebe '22 Artikel').
      const bubbleVorher = document.getElementById('cart-icon-bubble');
      const bubbleZahl = bubbleVorher ? (bubbleVorher.querySelector('span[aria-hidden="true"]') || bubbleVorher.querySelector('span')) : null;
      const zaehlerVorher = bubbleVorher ? (parseInt(((bubbleZahl || bubbleVorher).textContent || '').trim(), 10) || 0) : null;

      try {
        // mundizio v2 (05.09.2026): kein Vorab-GET des alten Warenkorbs mehr (ein serieller
        // Roundtrip vor dem eigentlichen Add). Ob die Variante schon im Korb lag, sagt die
        // Add-Antwort: data.quantity ist die neue Zeilenmenge; ist sie groesser als die
        // bestellte Menge, war die Zeile schon da.
        const requestedQty = parseInt(formData.get('quantity'), 10) || 1;

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          // mundizio v2 (05.09.2026): Drawer sofort rendern, sobald die Antwort da ist.
          // Vorher wartete hier ein setTimeout von 700 ms (Haekchen-Animation am Button);
          // das Oeffnen des Drawers ist die Rueckmeldung, der Button zeigt is-success weiter.
          if (this.cartDrawer) {
            this.cartDrawer.renderContents(
              data,
              !quickAddDrawer && theme.settings.afterAtc === 'drawer'
            );
          } else if (window.location.pathname === theme.routes.cart) {
            const cartItems = document.querySelector('cart-items');
            if (cartItems) {
              if (cartItems.dataset.empty === 'true') {
                window.location.reload();
              } else {
                cartItems.refresh();
              }
            }
          }
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        // mundizio v2: Zeile existierte, wenn die neue Zeilenmenge ueber der bestellten liegt.
        const newLineQty = parseInt(data.quantity, 10) || requestedQty;
        const wasInCart = newLineQty > requestedQty;

        // Check if product was already in the cart
        if (wasInCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: newLineQty - requestedQty,
              newQuantity: newLineQty
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        // mundizio v3 (14.09.2026): Teil-Add bei Bestandsgrenze — Shopify legt die verfuegbare Menge ein und
        // antwortet 422 mit Hinweistext (gemessen: Menge 3 bei Bestand 2 -> 2 im Korb). Bisher blieb es beim
        // Text ohne Drawer und ohne on:cart:add. Ist der Korb jetzt groesser als vor dem Klick, wird wie beim
        // Erfolg gerendert, geoeffnet und das Ereignis gefeuert; der Hinweistext bleibt sichtbar.
        let teilAdd = false;
        try {
          if (this.cartDrawer && zaehlerVorher !== null) {
            const teilResponse = await fetch(`${theme.routes.cart}.js`);
            const teilCart = teilResponse.ok ? await teilResponse.json() : null;
            if (teilCart && teilCart.item_count > zaehlerVorher) {
              teilAdd = true;
              await this.cartDrawer.refresh(true);
              if (theme.settings.afterAtc === 'drawer' && !this.closest('quick-add-drawer')) this.cartDrawer.open();
              this.dispatchEvent(new CustomEvent('on:cart:add', {
                bubbles: true,
                detail: { cart: teilCart, variantId: Number(formData.get('id')) || null, teilAdd: true }
              }));
            }
          }
        } catch (teilFehler) { /* dann wie bisher */ }
        if (teilAdd) return;
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent
          }
        }));

        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
